import { domain } from 'modules/data';

import { IOffboardingContext } from '../../OffboardingContext';

export interface RequestsProps {
    companyId: string;
    isLoading: boolean;
    disabled: boolean;
    displayName: string;
    requests?: domain.RequestsParticipant[];
    isWorkflowManager?: boolean;
    quantityRequests?: number;
}

export enum RequestsColumnsIds {
    Warning = 'warning',
    RequestName = 'requestName',
    Step = 'step',
    Amount = 'amount',
    Replacement = 'replacement',
}

export interface MapToTableRowsParams {
    companyId: string;
    requests?: RequestsProps['requests'];
    selectedReplacements: IOffboardingContext['selectedReplacements'];
    requestReplacementMode: IOffboardingContext['requestReplacementMode'];
    isPayerOffboardingBetaFeature: boolean;
}
